import styled from 'styled-components';

export const Base = styled.div`
	background: ${({ theme }) => {
		// Use #2A2A2A for dark theme to match design, otherwise use gray[100] for light theme
		return theme.gray[0] === '#272727' ? '#2A2A2A' : theme.gray[100];
	}};
	border-radius: 8px;
	padding: 10px 12px;
	margin-bottom: 12px;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 4px;
`;

export const CheckIcon = styled.span`
	color: #4aff9e;
	font-size: 16px;
	flex-shrink: 0;
`;

export const Name = styled.div`
	font-size: 13px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[1000]};
	flex: 1;
`;

export const VersionBadge = styled.span`
	height: 20px;
	padding: 0 8px;
	background: #4a9eff;
	color: ${({ theme }) => theme.white};
	border-radius: 4px;
	font-size: 11px;
	font-weight: 500;
	display: inline-flex;
	align-items: center;
	flex-shrink: 0;
`;

export const Meta = styled.div`
	font-size: 10px;
	color: ${({ theme }) => theme.gray[400]};
`;

export const ComponentCount = styled.span`
	font-size: 10px;
	color: ${({ theme }) => theme.gray[400]};
`;

export const Buttons = styled.div`
	display: flex;
	gap: 8px;
	margin-bottom: 12px;
`;

export const Button = styled.button<{ primary?: boolean }>`
	flex: 1;
	height: 32px;
	border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	font-size: 12px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s;
	border: none;
	padding: 0;
	font-family: inherit;

	${({ primary, theme }) =>
		primary
			? `
		background: #4A9EFF;
		color: ${theme.white};

		&:hover {
			background: #3D8FEF;
			transform: translateY(-1px);
		}
	`
			: `
		background: transparent;
		color: ${theme.gray[1000]};
		border: 1px solid ${theme.gray[200]};

		&:hover {
			background: ${theme.gray[100]};
		}
	`}
`;

export const VersionSection = styled.div`
	background: ${({ theme }) => {
		// Use #2A2A2A for dark theme to match design, otherwise use gray[100] for light theme
		return theme.gray[0] === '#272727' ? '#2A2A2A' : theme.gray[100];
	}};
	border-radius: 8px;
	padding: 16px;
	margin-bottom: 12px;
`;

export const SectionLabel = styled.div`
	font-size: 11px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[400]};
	text-transform: uppercase;
	letter-spacing: 0.05em;
	margin-bottom: 12px;
`;

export const VersionItem = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 12px;
	padding: 8px 0;
`;

export const VersionDot = styled.div<{ green?: boolean; blue?: boolean }>`
	width: 8px;
	height: 8px;
	border-radius: 50%;
	flex-shrink: 0;
	margin-top: 4px;
	background: ${({ green, blue }) => {
		if (green) return '#4AFF9E';
		if (blue) return '#4A9EFF';
		return '#7D7D7D';
	}};
	box-shadow: ${({ green, blue }) => {
		if (green) return '0 0 4px rgba(74, 255, 158, 0.6)';
		if (blue) return '0 0 4px rgba(74, 158, 255, 0.6)';
		return 'none';
	}};
`;

export const VersionInfo = styled.div`
	flex: 1;
	min-width: 0;
`;

export const VersionLabel = styled.div`
	font-size: 13px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
`;

export const ReadyBadge = styled.span`
	background: #4aff9e;
	color: #1e1e1e;
	font-size: 10px;
	font-weight: 600;
	padding: 2px 6px;
	border-radius: 4px;
	flex-shrink: 0;
`;

export const ProcessingButton = styled.button`
	width: 100%;
	height: 36px;
	border-radius: 6px;
	background: ${({ theme }) => theme.gray[200]};
	color: ${({ theme }) => theme.gray[600]};
	font-size: 12px;
	font-weight: 500;
	cursor: not-allowed;
	transition: all 0.2s;
	border: none;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	font-family: inherit;
	margin-top: 12px;
	opacity: 0.6;
`;

export const UpdateButton = styled.button<{ disabled?: boolean }>`
	width: 100%;
	height: 36px;
	border-radius: 6px;
	background: #4a9eff;
	color: ${({ theme }) => theme.white};
	font-size: 12px;
	font-weight: 500;
	cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
	transition: all 0.2s;
	border: none;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	font-family: inherit;
	margin-top: 12px;
	opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};

	&:hover {
		background: ${({ disabled }) => (disabled ? '#4a9eff' : '#3d8fef')};
		transform: ${({ disabled }) => (disabled ? 'none' : 'translateY(-1px)')};
	}
`;
